if (!customElements.get('pre-order-form')) {
    class PreOrderForm extends HTMLElement {
      constructor() {
        super();
        this.preOrderButton = this.querySelector('[name="modal-button"]');
        this.preModal = document.querySelector('#pre-modal');
        this.modalClose = this.preModal.querySelector('.pre-close');
        this.modalCheckbox = this.preModal.querySelector('#agree');
        this.submitBtn = this.preModal.querySelector('#pre-confirmed');
        this.form = this.querySelector('product-form');
        this.vid = this.preModal.querySelector('[name="id"]');
        this.modalQuantity = this.preModal.querySelector('[name="quantity"]');
        this.formQuantity = this.querySelector('[name="quantity"]');

        this.addEventListener("click", this.handleClick);

        if(this.modalClose){
          this.modalClose.addEventListener('click', this.handleClose.bind(this));
        }

        if(this.modalCheckbox){
          this.modalCheckbox.addEventListener('change', this.handleCheckbox.bind(this));
        }

        document.addEventListener('on:variant:change', (event) => {
          this.handleVariantChange(event);
        })

        if(this.submitBtn){
          this.submitBtn.addEventListener('click', this.handleSubmit.bind(this));
        }
      }

      handleClick(evt){
        if(!evt.target.matches('[name="modal-button"]')) return;

        if(this.preModal){
          this.preModal.style.display = "flex";
          // here we would need to get the value of the quantity selector and push it to the modal form quantity
          this.modalQuantity.value = this.formQuantity.value;
        }
      }

      handleClose(evt){
        if(!evt.target.matches('.pre-close')) return;
         this.preModal.style.display = "none";
      }

      handleCheckbox(evt){
        if(!evt.target.matches('#agree')) return;
        if(this.modalCheckbox.checked){
          this.submitBtn.disabled = false;
        }else{
          this.submitBtn.disabled = true;
        }
      }

      handleVariantChange(event){
       this.vid.value = event.detail.variant.id;
      }
  
      /**
       * Handles submission of the product form.
       * @param {object} evt - Event object.
       */
       handleSubmit(evt) {
        if(!evt.target.matches('#pre-confirmed')) return;
        setTimeout(() => {
          this.preModal.style.display = "none";
        }, 5000)
        
      }

    }
  
    customElements.define('pre-order-form', PreOrderForm);
  }
  